"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranscendSyncScriptURL = exports.getTranscendScriptURL = exports.TranscendPreconnect = void 0;
const react_1 = __importDefault(require("react"));
const webapp_constants_1 = require("@eventbrite/webapp-constants");
const BASE = "https://cdntranscend.eventbrite.com";
const SYNC_URL = "https://synctranscend.eventbrite.com";
const PATH_MAP = {
    [webapp_constants_1.Stage.PROD]: `${BASE}/cm/f2747157-cf59-4ef1-8703-018defe51764/airgap.js`,
    [webapp_constants_1.Stage.PREPROD]: `${BASE}/cm/9b44bef2-b90b-46da-ab18-ba44cda40e3d/airgap.js`,
    [webapp_constants_1.Stage.TEST]: `${BASE}/cm/c6c1b980-f2c0-4e17-a731-49f6fe253025/airgap.js`,
    [webapp_constants_1.Stage.LOCAL]: `${BASE}/cm/c6c1b980-f2c0-4e17-a731-49f6fe253025/airgap.js`,
    [webapp_constants_1.Stage.DEV]: `${BASE}/cm/c6c1b980-f2c0-4e17-a731-49f6fe253025/airgap.js`,
};
const SYNC_URL_PATH_MAP = {
    [webapp_constants_1.Stage.PROD]: `${SYNC_URL}/consent-manager/f2747157-cf59-4ef1-8703-018defe51764`,
    [webapp_constants_1.Stage.PREPROD]: `${SYNC_URL}/consent-manager/9b44bef2-b90b-46da-ab18-ba44cda40e3d`,
    [webapp_constants_1.Stage.TEST]: `${SYNC_URL}/consent-manager/c6c1b980-f2c0-4e17-a731-49f6fe253025`,
    [webapp_constants_1.Stage.LOCAL]: `${SYNC_URL}/consent-manager/c6c1b980-f2c0-4e17-a731-49f6fe253025`,
    [webapp_constants_1.Stage.DEV]: `${SYNC_URL}/consent-manager/c6c1b980-f2c0-4e17-a731-49f6fe253025`,
};
const TranscendPreconnect = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("link", { rel: "preconnect", href: BASE }),
        react_1.default.createElement("link", { rel: "dns-prefetch", href: BASE }),
        react_1.default.createElement("link", { rel: "preconnect", href: SYNC_URL }),
        react_1.default.createElement("link", { rel: "dns-prefetch", href: SYNC_URL })));
};
exports.TranscendPreconnect = TranscendPreconnect;
const getTranscendScriptURL = (stage) => {
    return PATH_MAP[stage];
};
exports.getTranscendScriptURL = getTranscendScriptURL;
const getTranscendSyncScriptURL = (stage) => {
    return SYNC_URL_PATH_MAP[stage];
};
exports.getTranscendSyncScriptURL = getTranscendSyncScriptURL;
//# sourceMappingURL=Transcend.js.map